import { Component, OnInit } from '@angular/core';
import { Page } from 'src/app/shared/model/page';
import { NotificationFilterForm } from '../../anre/notifications-anre/models/NotificationFilterForm';
import { FinalClientNotificationsService } from '../services/final-client-notifications.service';

@Component({
  selector: 'app-final-client-notifications',
  templateUrl: './final-client-notifications.component.html',
  styleUrls: ['./final-client-notifications.component.scss']
})
export class FinalClientNotificationsComponent implements OnInit {

  public notifications: Page<Notification>;
  public paginationNotifications = [];
  public notificationFilterForm: NotificationFilterForm = new NotificationFilterForm();

  public notificationDisplaySettings = {
    actions: {
      custom: [
        {
          name: 'markRead',
          title: '<p class="p_mark_read">Marchează citit</p>'
        }
      ],
      add: false,
      edit: false,
      delete: false,
      position: 'right',
      columnTitle: 'Opțiuni',
    },
    hideSubHeader: true,
    columns: {
      authorName: {
        title: 'Nume de cod emițător'
      },
      description: {
        title: 'Descriere mesaj'
      },
      // author: {
      //   title: 'Emițător mesaj',
      //   valuePrepareFunction: (author) => { return author?.name; }
      // },
      // correlation: {
      //   title: 'Corelație',
      //   valuePrepareFunction: (correlation) => { return correlation?.name; }
      // },
      // message: {
      //   title: 'Mesaj',
      //   valuePrepareFunction: (message) => { return message?.name; }
      // },
      date: {
        title: 'Data',
        valuePrepareFunction: (value) => { return value ? new Date(value).toLocaleDateString('ro-RO') : '' }
      },
      read: {
        title: 'Status',
        valuePrepareFunction: (value) => { return value ? 'Citită' : 'Necitită' }
      }
    },
    rowClassFunction: (row) => {
      if (!row.data.read) {
        return 'read_color';
      } else {
        return 'mark_read';
      }
    }
  };

  constructor(private notificationService: FinalClientNotificationsService) { }

  ngOnInit(): void {
    this.getNotifications();
  }

  getNotifications(): void {
    this.searchNotifications();
  }

  searchNotifications(): void {
    this.notificationService.getNotifications(this.notificationFilterForm).subscribe((val) => {
      this.notifications = val;
      this.notificationFilterForm.pageOffset = val.number;
      this.paginationNotifications = [{ pageNumber: 0, className: 'page-item' }];
      for (let i = 1; i < val.totalPages; i++) {
        this.paginationNotifications.push({ pageNumber: i, className: 'page-item' });
      }
      this.paginationNotifications[this.notificationFilterForm.pageOffset].className = 'page-item active';
    });
  }

  changePage(page: any): void {
    this.notificationFilterForm.pageOffset = page.pageNumber;
    this.searchNotifications();
  }

  previousPage(): void {
    this.notificationFilterForm.pageOffset = this.notificationFilterForm.pageOffset === 0 ? 0 : this.notificationFilterForm.pageOffset - 1;
    this.searchNotifications();
  }

  nextPage(): void {
    this.notificationFilterForm.pageOffset = this.notificationFilterForm.pageOffset === this.notifications.totalPages - 1
      ? this.notificationFilterForm.pageOffset : this.notificationFilterForm.pageOffset + 1;
    this.searchNotifications();
  }

  onCustomActionNotifications(event: any): void {
    console.log(event);
    switch (event.action) {
      case 'markRead':
        event.data.read = true;
        this.notificationService.markNotificationViewed(event.data.id).subscribe(() => this.getNotifications());
        break;
    }
  }

}
